/* =========================================================
	SITE-WIDE JS
	- Mobile navigation
	- Submenus open/close on mobile
	- UIKit
========================================================= */

/* Mobile navigation ---------------- */
const outputElement = document.getElementById("navigation");

// Create condition that targets viewports smaller than 1280px
const smallViewport = window.matchMedia('(max-width: 1279px)');

const primaryMenu = document.querySelector('.links.primary');
const secondaryMenu = document.querySelector('.links.secondary');
const divider = document.querySelector('.nav-divider');
const navButton = document.querySelector('.menu-button');


function handleViewportChange(e) {
	// Check if the media query is true
	if (e.matches) {
		// Mobile nav
		primaryMenu.setAttribute("hidden", "");
		secondaryMenu.setAttribute("hidden", "");
		divider.setAttribute("hidden", "");

		navButton.addEventListener('click', function() {
			let expanded = this.getAttribute('aria-expanded') === 'true' || false;
			this.setAttribute('aria-expanded', !expanded);
			primaryMenu.hidden = !primaryMenu.hidden;
			secondaryMenu.hidden = !secondaryMenu.hidden;
			divider.hidden = !divider.hidden;
		});

	} else {
		primaryMenu.removeAttribute("hidden");
		secondaryMenu.removeAttribute("hidden");
		divider.removeAttribute("hidden");
		navButton.removeAttribute('aria-expanded');
	}
}

smallViewport.addEventListener('change', handleViewportChange);
handleViewportChange(smallViewport);


/* Submenus open/close on mobile ---------------- */
let submenuButtonItems = document.querySelectorAll(".submenu-button");
let submenuItems = document.querySelectorAll(".submenu");

submenuButtonItems.forEach(button => {
	button.addEventListener("click", () => {
		// Toggle aria-expanded attribute on the clicked button
		button.setAttribute("aria-expanded", button.getAttribute("aria-expanded") === "true" ? "false" : "true");

		// Toggle the visibility of the sibling submenu
		let sibling = button.nextElementSibling;
		if (button.getAttribute("aria-expanded") === "true") {
		  sibling.classList.remove("sr-only");
		} else {
		  sibling.classList.add("sr-only");
		}

		// Set aria-expanded to false on all other buttons except the clicked one
		submenuButtonItems.forEach(buttonItem => {
			if (buttonItem !== button) {
			  buttonItem.setAttribute("aria-expanded", "false");
			}
		 });

		 // Add .sr-only to all other submenus except the sibling
		 submenuItems.forEach(item => {
			if (item !== sibling) {
			  item.classList.add("sr-only");
			}
		 });
	});
});

/* UIKit ---------------- */
import UIkit from 'uikit';
